import { ShareLinkItemNode, ShareLinkNodeData, TreeState } from './tree-node';
import { TreeSortMode } from '../../shared/models';
import {
  FileInfo,
  OptionInfo,
  OptionVersionSimple,
  ProjectSubsection,
  ShareLink,
  ShareLinkAssetEntityTypes,
  ShareLinkSimple,
  ShareListResponse,
  TopicInfo,
} from '../../shared/interfaces';
import { ActivatedRoute } from '@angular/router';

export const SHARE_LINK_EVENT = {
  CREATE: 'SHARE_LINK:CREATED',
  UPDATE: 'SHARE_LINK:UPDATED',
  COPY_LINK: 'SHARE_LINK:COPY_LINK',
};

export interface ShareLinkAssetVM {
  topic?: TopicInfo;
  option?: OptionInfo;
  version?: OptionVersionSimple;
  file?: FileInfo;
  type: ShareLinkAssetEntityTypes;
  subsection?: ProjectSubsection;
}

export interface ShareLinkTreeState extends TreeState<ShareLinkNodeData> {
  shareRecord: Record<string, ShareLinkSimple[]>; // key is asset (subsection/topic/option/version/file) id
}

export type BuildShareLinkTreeParams = {
  list: ShareListResponse;
  sortMode: TreeSortMode;
  topics?: TopicInfo[];
  options?: OptionInfo[];
};
export type BuildShareLinkAssetParams = {
  parent: ShareLinkItemNode;
  sortMode?: TreeSortMode;
  topics?: TopicInfo[];
  options?: OptionInfo[];
};
export type SendMailBodyParams = {
  emails: string[];
  message: string;
};
export type ShareLinkRequestParams = {
  firstName: string;
  lastName: string;
  email: string;
  password?: string;
};

export interface SharePreviewTreeState extends TreeState<ShareLinkNodeData> {
  shareRecord: Record<string, ShareLinkSimple[]>; // key is asset (subsection/topic/option/version/file) id
}

export type SharePreviewTreeParams = {
  shareLink: ShareLink;
  options: OptionInfo[];
  topics: TopicInfo[];
  sortMode: TreeSortMode;
  subsection?: ProjectSubsection;
};

export type SubsectionReviewLinkErrorParams = {
  error: any;
  firstName: string;
  lastName: string;
  email: string;
  showOverlayMessage: boolean;
  route: ActivatedRoute;
  initFn: () => void;
  successFn?: (any) => void;
};

export type SubsectionReviewLinkParams = {
  route: ActivatedRoute;
  initFn: () => void;
  successFn: (any) => void;
};
